// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"6c243558","668":"b3d417b2","838":"26c3c355"}[chunkId] + ".js";
};